import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import { connect } from 'react-redux';
import loadingParams from '../misc/loadingParams';
import { loadTypes } from '../misc/combination.class';

import EditableText from "@components/EditableText";

import '../../styles.scss';
import {
  selectAllCombination,
  setActiveCombination,
  toggleSelectionOfCombination,
  chnageCombinationLoadType,
  updateCombination,
  setImportHeader,
  setImportUnit
} from '@reducers/selectors/loads/actions';
import { setPanelOptions } from '@reducers/options/panel/actions';
import { standardList, countryList } from '../../../../../app.values';
import { defaultUnits } from '@config';

import TableInput from "../../../components/TableInput";
import { APP_TEXTS } from '../../../../../texts/texts';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS, getTooltip } from '../../../../../../src/texts/tooltips';
import { MOMENT, LOAD } from '@reducers/units';

class DesignLoadingTable extends React.Component {

  static propTypes = {
    areAllSelected: PropTypes.any,
    combinations: PropTypes.any,
    handleImportData: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      isEdit: -1
    };
  }

  render() {
    return (
    <Table className="mb-0">
      <thead className="thead GeneralLoadingTable">
        <tr>
          <th>
            <input
              type="checkbox"
              checked={this.props.areAllSelected}
              onChange={() => this.props.selectAll(!this.props.areAllSelected)}
            />&nbsp;{APP_TEXTS.ANCHOR_SELECTION_NAME.Content}
          </th>
          {this.props.isImporting ? (
            <th colSpan="2"> 
              <div className="d-flex">
                <span className="text-x-large">[&nbsp;</span>
                <select
                  value={this.props.importUnits.load}
                  onChange={e => this.props.setImportUnit({ load: e.target.value })}
                  id="load"
                  className="form-control"
                >
                  <option value={LOAD.KILONEWTON}>{APP_TEXTS.KILONEWTON.Content}</option>
                  <option value={LOAD.NEWTON}>{APP_TEXTS.NEWTON.Content}</option>
                  <option value={LOAD.DECANEWTON}>{APP_TEXTS.DECANEWTON.Content}</option>
                  <option value={LOAD.POUND_FORCE}>{APP_TEXTS.POUND_FORCE.Content}</option>
                </select>
                <span className="text-x-large">&nbsp;/&nbsp;</span>
                <select
                  value={this.props.importUnits.moment}
                  onChange={e => this.props.setImportUnit({ moment: e.target.value })}
                  id="moment"
                  className="form-control"
                >
                  <option value={MOMENT.NEWTON_METERS}>{APP_TEXTS.NEWTON_METER.Content}</option>
                  <option value={MOMENT.KILONEWTON_METER}>{APP_TEXTS.KILONEWTON_METER.Content}</option>
                  <option value={MOMENT.DECANEWTON_METER}>{APP_TEXTS.DECANEWTON_METER.Content}</option>
                  <option value={MOMENT.FOOT_POUND_FORCE}>{APP_TEXTS.FOOT_POUND_FORCE.Content}</option>
                </select>
                <span className="text-x-large">&nbsp;]</span>
              </div>
            </th>
          ) : (
            <th colSpan="2">[{this.props.loadUnit}&nbsp;/&nbsp;{this.props.momentUnit && this.props.momentUnit.replace(' ', "\u00A0")}]</th>
          )}
          
          {this.props.isImporting ? this.props.importHeaders.map((header, hIdx) => (
            <th key={header + "-th"}>
              <select
                id={header + "-header"}
                key={header + "-header"}
                className="form-control"
                onChange={(e) => this.props.onLoadHeaderChange(hIdx, e.target.value)}
                value={header || ''}
              >
                {getLoadNames(this.props.designStandard).map(item => {
                  let name = item.key.replace('-header', '');
                  return (
                    <React.Fragment key={header + name + '-fragment'}>
                      <option key={header + '' + name} value={name}>
                        {name}
                      </option>
                      <option key={header + '-' + name} value={'-' + name}>
                        {'-' + name}
                      </option>
                    </React.Fragment>
                  );
                })}
              </select>
            </th>
          )) : getLoadNames(this.props.designStandard).map((item, index) => (
            <th key={item.key}>{item.value}</th>
          ))}
        </tr>
      </thead>

      <tbody className="tbody">
      {this.props.combinations.map((item, index) => {
        const data = item;

        return (
          <tr key={item.name + Date.now} className={`CombinationRow ${data.isActive && 'active'}`}>
          
            <td className="CombinationRow__title float-left">
              <input
                id={data.name}
                type="checkbox"
                checked={data.isSelected}
                onChange={() => {
                  this.props.setActive(index);
                  this.props.changeSelection(index);
                }}
                onFocus={() => this.props.setActive(index)}
              />
            
            <Tooltip content={APP_TOOLTIPS.TOOLTIP_DEFINE_NAME_LOAD_COMBINATION.Content}>
              <EditableText
                value={data.name}
                onClick={() => {
                  this.props.setActive(index);
                  this.setState({ isEdit: index });
                }}
                // onChange={value => this.props.updateCombination(index, { name: value })}
                onBlur={(value) => {
                  if (value) {
                    this.props.updateCombination(index, { name: value }, this.props.isImporting);
                    this.setState({ isEdit: -1 });
                  }
                }}
                isEdit={this.state.isEdit > -1 && Number(this.state.isEdit) === index}
                onPaste={(e) => {
                  if (!this.props.isImporting) {
                    this.props.handleImportData(e.clipboardData.getData('text'));
                    this.setState({ isEdit: -1 });
                    e.preventDefault();
                  }
                }}
              />
            </Tooltip>
            </td>
            
            <Tooltip content={APP_TOOLTIPS.TOOLTIP_SELECT_LOADS_TYPE.Content} flip={false}>
              <td colSpan="2">
              <select
                onClick={() => this.props.setActive(index)}
                className="custom-select custom-select-sm"
                value={data.loadType}
                onChange={e => this.props.changeLoadType(index, e.target.value)}
              >
                {this.props.country === countryList["New Zealand"] ? (
                  <React.Fragment>
                    {isSeismicAvailable(this.props.designStandard) && (
                      <option value={loadTypes.SEISMIC}>{APP_TEXTS.LOADS_TYPE_SEISMIC.Content}</option>
                    )}
                    {isStaticAvailable(this.props.designStandard) && (
                      <option value={loadTypes.STANDARD}>{APP_TEXTS.LOADS_TYPE_STANDARD.Content}</option>
                    )}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {isStaticAvailable(this.props.designStandard) && (
                      <option value={loadTypes.STANDARD}>{APP_TEXTS.LOADS_TYPE_STANDARD.Content}</option>
                    )}
                    {isSeismicAvailable(this.props.designStandard) && (
                      <option value={loadTypes.SEISMIC}>{APP_TEXTS.LOADS_TYPE_SEISMIC.Content}</option>
                    )}
                  </React.Fragment>
                )}
                {isFireAvailable(this.props.designStandard) && (
                  <option value={loadTypes.FIRE}>{APP_TEXTS.LOADS_TYPE_FIRE.Content}</option>
                )}
              </select>
            </td>
            </Tooltip>

            {loadingParams.map((obj, i) => (
              <td key={obj.title}>
                <Tooltip content={getTooltip(getLoadTooltipId(i, this.props))}>
                  <TableInput
                    onClick={() => {
                      this.props.setActive(index);
                    }}
                    onBlur={() => {
                      this.props.animatePanel(false, obj);
                    }}
                    onFocus={() => {
                      this.props.setActive(index); 
                      this.props.animatePanel(true, obj);
                    }}
                    onInput={(value, invalidNumber) =>  {
                      if (!invalidNumber) {
                        this.props.setPanelValue(obj, parseFloat(value));
                        this.props.updateCombination(index, { [obj.key]: parseFloat(value)}, this.props.isImporting);
                      }
                    }}
                    defaultUnit={getUnit(true, i, this.props)}
                    currentUnit={getUnit(false, i, this.props)}
                    value={+data[obj.title] || 0}
                  />
                </Tooltip>
              </td>
            ))}
          </tr>
        );
      })}
      </tbody>
    </Table>
    );}

}


function isStaticAvailable(designStd) {
  return (
    Number(designStd) === standardList['EU'] ||
    Number(designStd) === standardList['ICC.Post'] ||
    Number(designStd) === standardList['ICC.Cast'] ||
    Number(designStd) === standardList['AS5216'] ||
    Number(designStd) === standardList['ANZ'] ||
    Number(designStd) === standardList['CSA'] ||
    Number(designStd) === standardList['Masonry'] ||
    Number(designStd) === standardList['AnnexC']
    );
}

function isSeismicAvailable(designStd) {
  return (
    Number(designStd) === standardList['EU'] ||
    Number(designStd) === standardList['ICC.Post'] ||
    Number(designStd) === standardList['ICC.Cast'] ||
    Number(designStd) === standardList['CSA'] ||
    Number(designStd) === standardList['AS5216']
    );
}

function isFireAvailable(designStd) {
  return (
    Number(designStd) === standardList['EU'] 
    );
}

function getLoadNames(designStd) {
  if (Number(designStd) === standardList['EU'] || Number(designStd) === standardList['AnnexC']) {
    return [
      { key: "Nz-header", value: <span>N<sub>Ed</sub>,z</span> }, 
      { key: "Vx-header", value: <span>V<sub>Ed</sub>,x</span> },
      { key: "Vy-header", value: <span>V<sub>Ed</sub>,y</span> },
      { key: "Mz-header", value: <span>M<sub>Ed</sub>,z</span> },
      { key: "Mx-header", value: <span>M<sub>Ed</sub>,x</span> },
      { key: "My-header", value: <span>M<sub>Ed</sub>,y</span> }
    ];
  } else if (Number(designStd) === standardList['ANZ'] || Number(designStd) === standardList['AS5216']) {
    return [
      { key: "Nz-header", value: <span>Nz*</span> }, 
      { key: "Vx-header", value: <span>Vx*</span> },
      { key: "Vy-header", value: <span>Vy*</span> },
      { key: "Mz-header", value: <span>Mz*</span> },
      { key: "Mx-header", value: <span>Mx*</span> },
      { key: "My-header", value: <span>My*</span> }
    ];
  } else if(Number(designStd) === standardList['ICC.Cast'] || 
    Number(designStd) === standardList['ICC.Post'] || 
    Number(designStd) === standardList['CSA']) {
      return [
        { key: "Nz-header", value: <span>N<sub>uz</sub></span> }, 
        { key: "Vx-header", value: <span>V<sub>ux</sub></span> },
        { key: "Vy-header", value: <span>V<sub>uy</sub></span> },
        { key: "Mz-header", value: <span>M<sub>uz</sub></span> },
        { key: "Mx-header", value: <span>M<sub>ux</sub></span> },
        { key: "My-header", value: <span>M<sub>uy</sub></span> }
      ];
  } else {
    return [
      { key: "Nz-header", value: <span>N<sub>z</sub></span> }, 
      { key: "Vx-header", value: <span>V<sub>x</sub></span> },
      { key: "Vy-header", value: <span>V<sub>y</sub></span> },
      { key: "Mz-header", value: <span>M<sub>z</sub></span> },
      { key: "Mx-header", value: <span>M<sub>x</sub></span> },
      { key: "My-header", value: <span>M<sub>y</sub></span> }
    ];
  }
}

function getUnit(isDefault, idx, props) {
  let i;
  if (props.isImporting) {
    // importHeaders might contain - character
    i = loadingParams.findIndex(param => props.importHeaders[idx].includes(param.key));
  } else {
    i = idx;
  }
  if (isDefault)
    return i < 3 ? defaultUnits.LOAD : defaultUnits.MOMENT;
  else if (props.isImporting)
    return i < 3 ? props.importUnits.load : props.importUnits.moment;
  else 
    return i < 3 ? props.loadUnit : props.momentUnit;
}

function getLoadTooltipId(idx, props) {
  if (props.isImporting) {
    return loadingParams.find(param => props.importHeaders[idx].includes(param.key)).tooltip.Id;
  } else {
    return loadingParams[idx].tooltip.Id;
  }
}

const mapState = state => ({
  designStandard: Number(state.main.localization.designStandard),
  country: Number(state.main.localization.country),

  loadUnit: state.main.units.load,
  momentUnit: state.main.units.moment,
  isImporting: state.selectors.loads[state.main.appType].importState.isImporting,
  importHeaders: state.selectors.loads[state.main.appType].importState.headers,
  importUnits: state.selectors.loads[state.main.appType].importState.units,
});

const mapDispatch = dispatch => ({
  updateCombination: (index, options, isImporting) => {
    dispatch(updateCombination(index, options));
    if (isImporting) {
    // update 3D view loads
      dispatch(setActiveCombination(index));
    }
  },

  selectAll: checked => dispatch(selectAllCombination(checked)),

  animatePanel: (isActive, obj) => {
    dispatch(setPanelOptions({
      animate: {
        [obj.action]: {
          [obj.animationName]: {
            active: isActive
          }
        }
      }
    }));
  },
  setPanelValue: (obj, value) => {
    dispatch(setPanelOptions({
      animate: {
        [obj.action]: {
          [obj.animationName]: {
            fixed: !!value,
            value: value || null,
          }
        }
      }
    }));
  },

  setActive: (index) => {
    dispatch(setActiveCombination(index));
  },
  changeSelection: index => dispatch(toggleSelectionOfCombination(index)),
  changeLoadType: (index, value) => dispatch(chnageCombinationLoadType(index, value)),
  onLoadHeaderChange: (index, value) => dispatch(setImportHeader(index, value)),
  setImportUnit: (value) => dispatch(setImportUnit(value))
});

export default connect(mapState, mapDispatch)(DesignLoadingTable);



// WEBPACK FOOTER //
// ./src/views/Loads/GeneralLoading/DesignLoading/DesignLoadingTable/DesignLoadingTable.js